"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentlLabel = exports.StyledLink = exports.StyledBreadcrumbs = void 0;
const styles_1 = require("@mui/material/styles");
const react_router_dom_1 = require("react-router-dom");
const Breadcrumbs_1 = __importDefault(require("@mui/material/Breadcrumbs"));
exports.StyledBreadcrumbs = (0, styles_1.styled)(Breadcrumbs_1.default)(() => ({
    margin: "20px 100px 20px",
}));
exports.StyledLink = (0, styles_1.styled)(react_router_dom_1.Link)(({ theme }) => ({
    textDecoration: "none",
    color: theme.palette.grayScale.gray2,
    "&:hover": {
        textDecoration: "none",
    },
}));
exports.CurrentlLabel = (0, styles_1.styled)("span")(({ theme }) => ({
    color: theme.palette.grayScale.gray2,
    fontWeight: "bold",
}));
